const userAgent: string = navigator.userAgent.toLocaleLowerCase();

export const app: boolean = /pcon\./.test(userAgent);
export const android: boolean = /android/.test(userAgent);

declare global {
    interface Window {
        MSStream?: object;
    }
    // interface DOMTokenList {
    //     supports?: (value: string) => boolean;
    // }
}

export const ios: boolean =
    (/ipad|iphone|ipod/.test(userAgent) && !window.MSStream) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // iPad with iOS >= 13
/**
 * Returns 0 if no android device, else it returns Major-Part of android version e.g. 4.4.1 => 4
 */
export function androidVersion(): number {
    const ua: string = navigator.userAgent.toLocaleLowerCase();
    const match: RegExpMatchArray | null = ua.match(/android\s([0-9\.]*)/);
    return match ? parseInt(match[1],  10) : 0;
}

const isWKWebkit: boolean = Boolean(window.webkit == null ? false : window.webkit.messageHandlers);

const testAnchor: HTMLAnchorElement = document.createElement('a');

/**
 * code based on https://github.com/google/model-viewer/blob/master/packages/model-viewer/src/constants.ts
 */
export const iOSQuicklookArAvailable: boolean = (
    ios &&
    (
        (
            !isWKWebkit &&
            testAnchor.relList != null &&
            (testAnchor.relList as any).supports != null &&
            (testAnchor.relList as any).supports('ar')
        ) ||
        (isWKWebkit && Boolean(/CriOS\/|EdgiOS\/|FxiOS\/|GSA\/|DuckDuckGo\//.test(navigator.userAgent)))
    )
);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/utils/UserAgent.ts